import { useEffect, useState } from "react";

const links = [
  { href: "#services", label: "Services" },
  { href: "#audience", label: "Who We Serve" },
  { href: "#why", label: "Principles" },
  { href: "#founder", label: "Founder" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0B0E14]/80 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="px-6 sm:px-12 lg:px-24 max-w-[1400px] mx-auto h-20 flex items-center justify-between">
        <a href="#hero" className="flex items-center gap-3" data-testid="brand-link">
          <span className="w-2 h-2 bg-[#C5A059] rotate-45" />
          <span className="font-serif text-lg sm:text-xl tracking-tight">
            Grand Venture <span className="text-[#C5A059]">FZ</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-xs uppercase tracking-[0.2em] text-[#F8F9FA]/70 hover:text-[#C5A059] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="header-cta"
          className="hidden sm:inline-flex items-center gap-2 border border-[#C5A059]/60 text-[#C5A059] px-5 py-2.5 text-xs uppercase tracking-[0.2em] hover:bg-[#C5A059] hover:text-[#0B0E14] transition-colors duration-300"
        >
          Consult
        </a>
      </div>
    </header>
  );
}
